import { createContext } from "react";
var LearnLastActivityContext = /*#__PURE__*/createContext(undefined);
export default LearnLastActivityContext;